import React from 'react'
import PropTypes from 'prop-types'

import { Icon } from '../../ui-blocks'


export const StyleButton = ({ label, style, active, onToggle, icon }) => {

  const handleToggle = e => {
    e.preventDefault()
    onToggle(style)
  }


  const stateClassName = (active ? 'btn-dark' : 'btn-outline-dark')

  return (
    <button
      type="button"
      className={`btn mr-1 py-1 px-2 border-0 ${stateClassName}`}
      onMouseDown={handleToggle}
      aria-label={label}
    >
      {icon ? (
        <Icon icon={icon} className="m-0" />
      ) : (
          <strong>{label}</strong>
        )}
    </button>
  )
}


StyleButton.propTypes = {
  label: PropTypes.string.isRequired,
  style: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  icon: PropTypes.object
}
